import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  CreditCard,
  Building2,
  Trash2,
  Loader2,
} from "lucide-react";
import API from "../../utils/api";
import useModal from "../../hooks/use-modal";

const PaymentItem = (props) => {
  const { item, fetchMethods } = props;
  const [isDeleting, setIsDeleting] = useState(false);
  const { openModal, closeModal, modalTypes } = useModal();

  const getIconByType = (type) => {
    switch (type) {
      case "CHECKING":
      case "SAVINGS":
        return Building2;
      default:
        return CreditCard;
    }
  };

  const getCardTypeColor = (type) => {
    switch (type) {
      case "CHECKING":
      case "SAVINGS":
        return "from-green-400 to-emerald-500";
      default:
        return "from-blue-400 to-purple-500";
    }
  };


  const removeMethod = async (id) => {
    if (!isDeleting) {
      try {
        setIsDeleting(true);
        const del = await API.delete("/payment-methods/" + id);
        if (del.data.result_code) {
          // TODO: Replace with toast notification
          alert(
            "Error removing payment method. You may have pending payments."
          );
        }
        await fetchMethods();
      } catch (e) {
        console.error("Failed to remove payment method:", e);
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const handleRemoveClick = () => {
    openModal(modalTypes.ModalConfirmDeletePayment, {
      paymentMethod: item,
      onConfirm: removeMethod,
      onCancel: closeModal,
    });
  };

  const Icon = getIconByType(item.method_type);
  const gradientColor = getCardTypeColor(item.method_type);

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`
        relative p-4 bg-white/[0.03] backdrop-blur-sm rounded-xl border border-white/10 
        hover:bg-white/[0.06] hover:border-white/20 transition-all
        ${isDeleting ? "opacity-50 pointer-events-none" : ""}
      `}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Icon Container */}
          <div
            className={`p-3 bg-gradient-to-br ${gradientColor} bg-opacity-20 rounded-lg`}
          >
            <Icon className="w-5 h-5 text-white" />
          </div>

          {/* Payment Method Details */}
          <div className="flex flex-col">
            <span className="font-medium text-white">
              {item.method_desc}
            </span>
            <span className="text-sm text-gray-400">
              {item.method_type === "CHECKING" || item.method_type === "SAVINGS"
                ? "Bank Payment Method"
                : "Card Payment Method"}
            </span>
          </div>

        </div>

        {/* Delete Action */}
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveClick();
          }}
          className="p-2 text-gray-400 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-all"
          disabled={isDeleting}
          aria-label="Remove payment method"
        >
          {isDeleting ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <Trash2 className="w-4 h-4" />
          )}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default PaymentItem;
